import { removeCard as _deleteCard } from "@bonliva/react-kanban";
import { BoardDescription } from "./kanban-types";

export function deleteCard(state: BoardDescription<any>, cardId: string) {
  const column = state.columns.find((col) =>
    col.cards.find((card) => card.id === cardId)
  );

  if (!column) {
    return state;
  }

  const card = column.cards.find((card) => card.id === cardId);

  if (!card) {
    return state;
  }

  return _deleteCard(state, column, card);
}
